import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import { SiteSizeEnum, type SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'bg-site-accent-600 text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'border-site-accent-600'],
  [SiteVariantEnum.Tertiary, ''],
  [SiteVariantEnum.TextOnly, 'text-site-accent-600'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'hover:bg-site-accent-700'],
  [SiteVariantEnum.Secondary, 'hover:bg-site-accent-600'],
  [SiteVariantEnum.Tertiary, 'hover:text-site-accent-700'],
  [SiteVariantEnum.TextOnly, ''],
]);

const buttonActiveClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'active:bg-site-accent-800'],
  [SiteVariantEnum.Secondary, 'active:border-site-accent-800'],
  [SiteVariantEnum.Tertiary, 'active:text-site-accent-800'],
  [SiteVariantEnum.TextOnly, 'active:text-site-accent-800'],
]);

const buttonShadowClasses = 'focus:shadow-site-accent-50';

/**
 * Size per Variants
 */

const buttonTertiarySizeClassesMap = new MatchedMap([
  [SiteSizeEnum.Small, 'text-site-accent-800'],
  [SiteSizeEnum.Medium, 'text-site-accent-800'],
  [SiteSizeEnum.Large, 'text-site-accent-600'],
  [SiteSizeEnum.XLarge, 'text-site-accent-600'],
]);

const buttonTextOnlySizeClassesMap = new MatchedMap([
  [SiteSizeEnum.Small, 'hover:text-site-accent-700 focus:text-site-accent-800'],
  [SiteSizeEnum.Medium, 'hover:text-site-accent-700 focus:text-site-accent-800'],
  [SiteSizeEnum.Large, 'hover:text-site-accent-600 focus:text-site-accent-600'],
  [SiteSizeEnum.XLarge, 'hover:text-site-accent-600 focus:text-site-accent-600'],
]);

/**
 * Site Theme / Blue Light Button Size Variant
 */

const buttonSizeClassesMap = (size: SiteSizeType) =>
  new MatchedMap([
    [SiteVariantEnum.Primary, ''],
    [SiteVariantEnum.Secondary, ''],
    [SiteVariantEnum.Tertiary, buttonTertiarySizeClassesMap.get(SiteSizeEnum[size])],
    [SiteVariantEnum.TextOnly, buttonTextOnlySizeClassesMap.get(SiteSizeEnum[size])],
  ]);

/**
 * Site Theme / Blue Light Button Color Variant
 */

const buttonSiteBlueLightTheme = (size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [
    buttonClassesMap,
    buttonHoverClassesMap,
    buttonActiveClassesMap,
    buttonSizeClassesMap(size),
  ],
  buttonSiteVariantColorShadowClasses: buttonShadowClasses,
});

export default buttonSiteBlueLightTheme;
